import { render, staticRenderFns } from "./page.vue?vue&type=template&id=f069e63c&scoped=true&"
import script from "./page.vue?vue&type=script&lang=js&"
export * from "./page.vue?vue&type=script&lang=js&"
import style0 from "./page.vue?vue&type=style&index=0&id=f069e63c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f069e63c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2026/Temperature/TempAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f069e63c')) {
      api.createRecord('f069e63c', component.options)
    } else {
      api.reload('f069e63c', component.options)
    }
    module.hot.accept("./page.vue?vue&type=template&id=f069e63c&scoped=true&", function () {
      api.rerender('f069e63c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/index/page.vue"
export default component.exports